import imagesLoaded from 'imagesloaded';
import mq from 'enquire.js';
import { Breakpoints } from 'JBSrc/constants';

jQuery($ => {
	const bannerParent = $('.home-banner');
	const banner = $('.home-banner__heading-image');
	const bannerImage = $('.home-banner__heading-image img');
	const bannerTagline = $('.home-banner__tagline');
	const bannerVideo = $('.home-banner video');

	if (!bannerParent.length) {
		return;
	}

	let scrollTop = window.scrollY;

	function handleScroll() {
		scrollTop = window.scrollY;

		if (scrollTop <= bannerParent.height()) {
			mq.register(`screen and (min-width: ${Breakpoints.sm}px)`, {
				match: () => {
					banner.css({ opacity: 1 - scrollTop / 800 });
					banner.css({ transform: `translateY(${scrollTop * +0.15}px)` });
				}
			});
		}
	}

	$(window).on('scroll', handleScroll);
});
